import { DatePicker, Modal, message } from 'antd';
import React, { Component } from 'react';
import API_URL from "../../../../common/url";
import $ from '../../../../common/AjaxRequest';
import ExportUtil from '../../../../common/ExportUtil';
import moment from 'moment';

const { MonthPicker } = DatePicker;

export default class ExportFixedLine extends Component {

    state = {
        visible: false,
        loading: false,
        yearMonth: '',
        monthData: [],
    }

    show = () => {
        this.setState({
            visible: true,
        },() => {
            this.loadYearMonth();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadYearMonth = () => {
        const options = {
            method: 'POST',
            url: API_URL.contract.queryAllCustomerCompanyRecordYearMonthList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                this.setState({ 
                    monthData: datas,
                    yearMonth: datas[0] ? String(datas[datas.length - 1]) : '',
                });
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { yearMonth } = this.state;
        const url = API_URL.contract.exportCustomerCompanyRecordList;
        ExportUtil.export({ yearMonth: Number(yearMonth) }, null, url);
        this.hide();
    }

    handleChange = (value) => {
        if (value) {
            this.setState({ yearMonth: moment(value).format('YYYYMM')})
        } else {
            this.setState({ yearMonth: ''})
        }
    }

    disabledDate = (current) => {
		const { monthData } = this.state;
		return !(monthData || []).some(el => el == current.format('YYYYMM'))
	}

    render() {
        const { visible, loading, yearMonth } = this.state;
        return (
            <Modal
                title="导出固化数据"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width={500}
                bodyStyle={{
                    minHeight: 100
                }}
            >
                <div className="modal-content" style={{ padding: '30px 20px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">请选择固化月份：</div>
                                <div className="item-right">
                                    <MonthPicker
                                        placeholder='请选择'
                                        disabledDate={this.disabledDate}
                                        value={yearMonth ? moment(yearMonth) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString)}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/ExportFixedLine.js